import { WarriorBattle } from '~/../api/common.types';
import NamingDetails from '~/components/naming/NamingDetails';

const NamingSuccess = ({
  warrior,
  name,
}: {
  warrior: WarriorBattle;
  name: string;
}) => {
  return (
    <>
      <div className="name-warrior--wrapper warrior-name-success">
        <div className="warrior-name mb-space-m">
          <h2 className="warrior-name__text">{name}</h2>
          <div className="warrior-name__media">
            <img
              src={warrior.dead ? warrior.images.dead : warrior.images.active}
              className={warrior.dead ? 'warrior-name--dead' : ''}
              alt={`Warrior image for ${name}`}
            />
          </div>
          <NamingDetails warrior={warrior} isSuccess={true} />
        </div>
      </div>
    </>
  );
};

export default NamingSuccess;
